<template>
  <div class="hello">
    <transition name="fade">
        <div v-if="performingRequest" class="loading">
            <p>Loading..</p>
        </div>
    </transition>

    <b-container>
          <b-card v-if="thisInvoice" style="margin-top:20px" :title="'Invoice for ' + thisInvoice.pub" border-variant="dark">
                <b-container style="border-width:10px; border-color:black; margin-top:20px">

                    <b-row>
                        <hr>
                        <b-col>
                            <h4 style="color:#2e5189">{{thisInvoice.brewer}}</h4>
                            {{thisInvoice.paymentaddress}}
                        </b-col>
                        <b-col>
                            <h4 style="color:#2e5189">INVOICE</h4>
                           <div> Date: {{thisInvoice.createddatetime.date}} {{thisInvoice.createddatetime.month}}, {{thisInvoice.createddatetime.year}}</div>
                            Invoice Number: {{thisInvoice.invoicenumber}}
                            <br>
                            DUE DATE: {{thisInvoice.duedatetime.date}} {{thisInvoice.duedatetime.month}}, {{thisInvoice.duedatetime.year}}

                        </b-col>
                    </b-row>
                    <!-- Buyer name and address -->
                    <b-row >
                        <b-col>
                            <h5 style="color:#2e5189">BILL TO</h5>
                            {{thisInvoice.pub}}
                            <br>
                            {{thisInvoice.billingaddress}}
                            <!-- Must change this to billing address -->
                        </b-col>
                    </b-row>

                    <!-- Order details -->
                    <table class="table table-bordered ">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col">DATE</th>
                                <th scope="col">DESCRIPTION</th>
                                <th scope="col">QUANTITY</th>
                                <th scope="col">TAXES</th>
                                <th scope="col">AMOUNT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Iterate over items for the same buyer -->
                            <tr v-for="order in thisInvoice.orders" :key="order.suborderid">
                                <td style="width:10%; padding-top:17px"><small>{{order.orderDate}}</small></td>
                                <td style="width:50%">{{order.itemName}}</td>
                                <td style="width:10%">{{order.orderQuantity}}</td>
                                <td style="width:10%">
                                    {{order.tax}}
                                </td>
                                <td style="width:10%">
                                    {{order.totalCost}}
                                </td>
                            </tr>
                            <!-- Discount -->
                            <tr>
                                <td v-if="thisInvoice.discount" colspan="2">Discount</td>
                                <td colspan="3">{{thisInvoice.discount}}</td>
                            </tr>
                            <!-- Credit -->
                            <tr>
                                <td v-if="thisInvoice.credit" colspan="2">Credit</td>
                                <td colspan="3">{{thisInvoice.credit}}</td>
                            </tr>
                            <!-- Deposit -->
                            <tr>
                                <td v-if="thisInvoice.deposit" colspan="2">Deposit</td>
                                <td colspan="3">{{thisInvoice.deposit}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- Total Cost -->
                    <b-row>
                        <b-col></b-col>
                        <b-col>
                            <h5 style="text-align:right">TOTAL  ${{thisInvoice.total}}</h5>
                        </b-col>
                    </b-row>
                    
                    
                    <!-- Payment instructions -->
                    <b-row >
                        <b-col>
                            <h5 style="padding-left:12px; ">Payment Instructions</h5>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            {{thisInvoice.paymentinstructions}}
                        </b-col>
                    </b-row>
                    
                </b-container>
            </b-card>
            <b-row style="height:200px">
                <b-col>
                </b-col>
            </b-row>
    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import {timeConverterObject, copyObject} from '../Myfunctions'
const fb = require('../../firebaseConfig.js')

export default {    
    props: ['invoicenumber', 'invoicedocid'],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
    },

    data() {
        return {
            thisInvoice:{
                createddatetime:'',
                duedatetime:'',
            },
            performingRequest:false,
        }
    },

    methods:{
        getInvoice(){
            //Get invoice from FB
            console.log("Fetching invoice number " + this.invoicenumber )
            fb.invoicesCollection.where('invoicenumber', '==', this.invoicenumber).get().then(docs => {
                docs.forEach(doc => {
                    console.log("Got invoice")
                    var invoiceData=doc.data()
                    console.log("Invoice = ")
                    console.log(invoiceData)
                    invoiceData.createddatetime = timeConverterObject(invoiceData.createdOn.seconds)
                    invoiceData.duedatetime = timeConverterObject(invoiceData.duedate.seconds)

                    this.thisInvoice=invoiceData
                    
                    this.performingRequest=false
                })
            }).catch(err => {
                console.log(err)
                this.performingRequest = false
            })
        },
        getInvoiceWithId(){
            var invoicesRef = fb.invoicesCollection.doc(this.invoicedocid);
            invoicesRef.get().then((doc) => {
            if (doc.exists) {
                    console.log("Document data:", doc.data());
                    var invoiceData=doc.data()
                    invoiceData.createddatetime = timeConverterObject(invoiceData.createdOn.seconds)
                    invoiceData.duedatetime = timeConverterObject(invoiceData.duedate.seconds)

                    this.thisInvoice=invoiceData
                    
                    this.performingRequest=false
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch((error) => {
                console.log("Error getting document:", error);
            });
        },
    },

    mounted(){
        this.performingRequest=true
        this.getInvoiceWithId()
    },
}
</script>

